(function($) {
    'use strict';

    class FieldActivator {
        constructor(form) {
            this.form = form;
            this.bindEvents();
        }

        bindEvents() {
            this.form.$form.on('change', 'input, select', (e) => {
                this.handleFieldCompletion(e);
            });

            this.form.$form.on('input', 'input[type="text"], .number-input', (e) => {
                this.handleTextInput(e);
            });

            this.form.$form.on('change', 'input[type="radio"]', (e) => {
                this.handleRadioChange(e);
            });
        }

        handleFieldCompletion(e) {
            const $currentField = $(e.target).closest('.salary-calculator__form__field');
            const $nextField = $currentField.next('.salary-calculator__form__field');
            
            if (this.isFieldComplete($currentField)) {
                $currentField.addClass('completed');
                
                if ($nextField.length) {
                    this.activateField($nextField);
                }
            } else {
                $currentField.removeClass('completed');
            }

            this.updateCalculateButton();
        }

        handleTextInput(e) {
            const $field = $(e.target).closest('.salary-calculator__form__field');
            const value = $(e.target).val();

            if (value) {
                $field.addClass('active');
            }
        }

        handleRadioChange(e) {
            const $currentField = $(e.target).closest('.salary-calculator__form__field');
            const $nextField = $currentField.next('.salary-calculator__form__field');

            $currentField.addClass('completed');
            
            if ($nextField.length) {
                this.activateField($nextField);
            }

            this.updateCalculateButton();
        }

        activateField($field) {
            $field.addClass('active');
            
            // Если поле уже заполнено, активируем следующее
            if (this.isFieldComplete($field)) {
                const $nextField = $field.next('.salary-calculator__form__field');
                if ($nextField.length) {
                    this.activateField($nextField);
                }
            }
        }

        isFieldComplete($field) {
            const $input = $field.find('input, select');
            
            if ($input.attr('type') === 'radio') {
                return $field.find('input[type="radio"]:checked').length > 0;
            }
            
            return $input.val() && $input.val().trim() !== '';
        }

        updateCalculateButton() {
            const allFieldsComplete = this.form.$fields.toArray()
                .every(field => this.isFieldComplete($(field)));

            this.form.$calculateButton.prop('disabled', !allFieldsComplete);
            
            if (allFieldsComplete) {
                this.form.$calculateButton.addClass('ready');
            } else {
                this.form.$calculateButton.removeClass('ready');
            }
        }
    }

    window.FieldActivator = FieldActivator;

})(jQuery); 